import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

// Import images
// import PlantLogo from "../assets/plant_logo.webp";
// import ProductLogo from "../assets/product_logo.jpg";
// import SolutionLogo from "../assets/solution_logo.png";
// import ContactLogo from "../assets/contact_logo.png";

function Footer() {

  return (
    <footer className="footer">
      {/* <div className="quick-links">
          <div className="quick-link-item">
            <img src={PlantLogo} alt="Vastu Plants" />
            <p>Vastu Plants</p>
          </div>
          <div className="quick-link-item">
            <img src={PlantLogo} alt="Vastu Products" />
            <p>Vastu Products</p>
          </div>
          <div className="quick-link-item">
            <img src={PlantLogo} alt="Vastu Solutions" />
            <p>Vastu Solutions</p>
          </div>
          <div className="quick-link-item">
            <img src={PlantLogo} alt="Combos" />
            <p>Combo</p>
          </div>
      </div> */}
      <div className="footer-container">
        {/* Quick Links Section */}

        {/* Default Footer Content */}
        <p className="footer-summary">
          © 2025 Code CentricAI. All rights reserved. 
          {/* <button className="expand-footer-btn" 
          onClick={handleExpand}
          >
            {expanded ? "Hide Details" : "Details"}
          </button> */}
        </p>

        {/* Expanded Footer Details */}
        <div className={"footer-details show" }>
          <div className="footer-section">
            <h5>About Us</h5>
            <p>
              Vastu Salahkar is your one-stop solution for all Vastu remedies,
              products, and expert consultations.
            </p>
          </div>
          <div className="footer-section">
            <h5>Quick Links</h5>
            <ul>
              <li><Link className="nav-link" to="/">Home</Link></li>
              <li><Link className="nav-link" to="/recommendations">Vastu Recommendations</Link></li>
              <li><Link className="nav-link" to="/about">About Us</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h5>Contact Us</h5>
            <p>Email: yourvastusalahkar@gmail.com</p>
            <p>Phone: +91 96302 00743</p>
            <p>Address: Indore, Indore City, M.P., India</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
